import { Box, Skeleton } from "@mui/material";
import React from "react";

export const LoadingSkeleton = () => (
  <Box style={{ display: "flex", flexDirection: "column", gap: "1rem", paddingTop: "1rem" }}>
    <Box style={{ display: "flex", gap: "1rem", width: "70%" }}>
      <Skeleton variant="rectangular" height={30} width="100%" />
      <Skeleton variant="rectangular" height={30} width="100%" />
      <Skeleton variant="rectangular" height={30} width="100%" />
      <Skeleton variant="rectangular" height={30} width="100%" />
      <Skeleton variant="rectangular" height={30} width="100%" />
    </Box>
    <Skeleton variant="rectangular" height={80} width="100%" />
    <Skeleton variant="rectangular" height={80} width="100%" />
    <Skeleton variant="rectangular" height={80} width="100%" />
  </Box>
);